import * as THREE from 'three';
import { Camera } from 'three';


export class ScreenSize {


    public static stageWidth:number = 0;
    public static stageHeight:number = 0;
    public static aspectHW:number = 1;

    public static isWideScreen():boolean {

        return ScreenSize.aspectHW < 0.8;

    }

    public static GetDotSize():number{
        
        let size:number=4;
        
        if(window.innerWidth<1000)size=3;
        
        return size;

    }

    public static ResizeCamera(camera:THREE.OrthographicCamera){

        ScreenSize.aspectHW = window.innerHeight/document.body.clientWidth;//window.innerWidth;
        
        let aspect:number = ScreenSize.aspectHW;//window.innerHeight/window.innerWidth;
        
        if(ScreenSize.isWideScreen()){
            let width:number = 1850/2;
            camera.left= -width;
            camera.right= width;
            camera.top=width*aspect;
            camera.bottom=-width*aspect;//.innerHeight*scl;
        }else{
            let height:number = 1000/2;
            camera.left= -height/aspect;
            camera.right= height/aspect;
            camera.top=height;
            camera.bottom=-height;//.innerHeight*scl;
        }

        ScreenSize.stageWidth=Math.abs(camera.left)*2;
        ScreenSize.stageHeight=Math.abs(camera.top)*2;
        
        //console.log("resize1",window.innerWidth,window.innerHeight);
        //console.log("resize2",ScreenSize.stageWidth,ScreenSize.stageHeight);
        
    }



}